export class ExpensesEditableGridModel {
  rowId?: number = 0;
  accountUid?: string = null;
  accountName?: string = null;
  remark?: string = null;
  currency?: string = null;
  rate?: number = null;
  baseAmount?: number = null;
  amount?: number = 0;
  net?: number = 0;
  tax?: string = null;
  taxName?: string = null;
  taxRate?: number = null;
  taxAmount?: number = null;
  //debit?: number = 0;
  //credit?: number = 0;
  isReadOnly?: boolean = false;
  budgetSheetItemUid?: string = null;
  budgetSheetItemName?: string = null;
}
